// The single resolver lives in the blocking, nonced index.html script.
export type ThemeChoice = "system" | "light" | "dark";
declare global {
  interface Window { taTheme: { get(): ThemeChoice; set(choice: ThemeChoice): void } }
}
export const themePreference = (): ThemeChoice => window.taTheme.get();
export const chooseTheme = (choice: ThemeChoice): void => window.taTheme.set(choice);
